export const HOST_URL = '/';
export const LOGIN_PATH = 'api/login';
